import axios from '@/plugins/axios'
import store from '@/store/index.js'

export async function getTimeIdle (company) {
  let getTime = 0
  const response = await axios.get('prparametros/auth/timeout', {
    params: {
      parametro: 'TIMEOUT_APP',
      company
    }
  })
  getTime = (response.data.data * 60)
  return getTime
}
